/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_N7Inputs */

const en_csv_to_json_ref_n7 = /** @type {(inputs: Csv_To_Json_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carriage return and line feed pairs are handled, so Windows files need no conversion.`)
};

const ko_csv_to_json_ref_n7 = /** @type {(inputs: Csv_To_Json_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캐리지 리턴과 라인 피드 쌍이 처리되므로 Windows 파일에 변환이 필요 없습니다.`)
};

const ja_csv_to_json_ref_n7 = /** @type {(inputs: Csv_To_Json_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャリッジリターンとラインフィードの対が処理されるので、Windows のファイルに変換は不要です。`)
};

/**
* | output |
* | --- |
* | "Carriage return and line feed pairs are handled, so Windows files need no conversion." |
*
* @param {Csv_To_Json_Ref_N7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_n7 = /** @type {((inputs?: Csv_To_Json_Ref_N7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_N7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_n7(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_n7(inputs)
	return ja_csv_to_json_ref_n7(inputs)
});